var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseXThick = function SvgCloseXThick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.886 12 5.723 5.724a1.333 1.333 0 1 1-1.885 1.885L12 13.886l-5.724 5.723a1.333 1.333 0 1 1-1.885-1.885L10.114 12 4.391 6.276a1.333 1.333 0 0 1 1.885-1.885L12 10.114l5.724-5.723a1.333 1.333 0 0 1 1.885 1.885z"
  })));
};
export default SvgCloseXThick;